/**
 * The refused test calls after which the dialog's preview is out of date.
 *
 * An alert call (ring R9) is rechecked right before dialling, and the recheck
 * writes its verdict to the incident: a defect that is gone is resolved for
 * everyone. The route then picks the defect again on every press, so after
 * one of these refusals the defect and the opening on screen may no longer be
 * what the next press would ring about (another open defect, or none). The
 * dialog reads the preview again and keeps the refusal on screen.
 *
 * React-free: `staleAlertRefusal.test.ts` runs it under plain node.
 */

/** The route's `no_alert` and the four refusals of the pre-dial recheck. */
export const STALE_ALERT_REFUSALS = ["no_alert", "defect_gone", "alert_unchecked", "alert_too_old", "alert_called"] as const;

const STALE: ReadonlySet<string> = new Set(STALE_ALERT_REFUSALS);

/** The refusal (a `testCallError` key) means the preview must be read again before another press. */
export function refusalRereadsPreview(key: string): boolean {
  return STALE.has(key);
}
